const ar = {
  navbar: {
    trackCase: "تتبع قضية",
  },
};

export default ar;
